import React from 'react'
import CountUp from 'react-countup';
import PropTypes from "prop-types"


function Count({ end, duration, title, className, animation }) {
  return (
    <div className={className}>
      <CountUp
        end={end}
        delay={0}
        duration={duration}
      >
        {({ countUpRef }) => (
          <div>
            <h1 data-aos={animation} className="text-center text-white">{title}</h1>
            <h1 data-aos={animation} className="text-center text-white"><span ref={countUpRef} /></h1>

          </div>
        )}
      </CountUp>
    </div>
  )
}

Count.propTypes = {
  end: PropTypes.number,
  duration: PropTypes.number,
  title: PropTypes.string,
  className: PropTypes.string,
  animation: PropTypes.string
}

export default function Statistics() {
  return (
    <section id="statistics">
      <div className="flex flex-row bg-main_color justify-center items-center" style={{ height: '500px' }}>
        <Count animation='slide-left' end={1000} duration={3.75} title={'Pacientes atendidos'} className="p-10" />
        <Count animation='slide-left' end={10} duration={7.75} title={'Años de experiencia'} className="justify-center items-center" />
        <Count animation='slide-right' end={32} duration={5.75} title={'Número de especialistas'} className="p-10" />
        <Count animation='slide-right' end={300} duration={6.75} title={'Aportes cientificos'} className="p-10" />
      </div>
    </section>
  )
}